<mat-progress-bar color="accent" *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
